import { render, staticRenderFns } from "./carousel-certifications-cmp.vue?vue&type=template&id=9e994432&scoped=true"
import script from "./carousel-certifications-cmp.vue?vue&type=script&lang=js"
export * from "./carousel-certifications-cmp.vue?vue&type=script&lang=js"
import style0 from "./carousel-certifications-cmp.vue?vue&type=style&index=0&id=9e994432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e994432",
  null
  
)

export default component.exports